// utils/downloadFile.js
import axios from "axios";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import { FomatText } from "./formatText";

/**
 * Downloads data from the API and triggers download as PDF or CSV.
 *
 * @param {string} url - API endpoint to fetch data from
 * @param {'pdf' | 'csv'} format - Desired file format
 * @param {string} fileName - Name of the downloaded file
 */

export const downloadFile = async ({
  data,
  format = "pdf",
  fileName = "report",
}) => {
  //   try {
  //     const response = await axios.get(url);
  //     const data = response.data;

  if (!data || data.length === 0) {
    alert("No data to download");
    return;
  }

  if (format === "csv") {
    const csv = Papa.unparse(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.csv`;
    link.click();
  }

  console.log("data 123", data);

  if (format === "pdf") {
    const doc = new jsPDF();
    const headers = Object.keys(data[0]);
    const rows = data.map((item) => headers.map((header) => item[header]));

    //   doc.autoTable({
    //     head: [headers],
    //     body: rows,
    //   });

    doc.setFontSize(16);
    doc.text("Campaign Report", 14, 22); // Title

    doc.autoTable({
      startY: 10,
      head: [headers],
      body: rows,
      columnStyles: {
        0: { cellWidth: 20 }, // column 0 (first)
        1: { cellWidth: 25 }, // column 1
        2: { cellWidth: 25 },
        3: { cellWidth: 25 },
        4: { cellWidth: 25 },
        5: { cellWidth: 25 },
        6: { cellWidth: 25 },
        7: { cellWidth: 25 },
        8: { cellWidth: 25 },
        9: { cellWidth: 25 },
        10: { cellWidth: 25 },
        // ...and so on
      },
      theme: "grid", // or 'striped', 'plain'
      styles: {
        fontSize: 8,
        cellPadding: 3,
      },
      headStyles: {
        fillColor: [52, 152, 219], // blue
        textColor: [255, 255, 255], // white
        fontStyle: "bold",
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240],
      },
      margin: { top: 30 },
    });

    doc.save(`${fileName}.pdf`);
  }

};
